export const AttributeColumnName = {
  DIMENSIONS: 'Dimensions',
  FULFILLMENTS: 'Fulfillments'
};
